import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import * as superAdminActions from '../../ducks/super-admin'
import UsageLog from '../UsageLog'

class UsageLogContainer extends React.Component {
  componentWillUnmount() {
    this.props.actions.fetchUsageSummary()
  }

  render() {
    return (
      <UsageLog
        usageLog={this.props.usageLog}
        onSummarize={this.props.actions.fetchUsageSummary}
        isSuperAdminView={true}
      />
    )
  }
}

function mapStateToProps(state) {
  return {
    usageLog: state.superAdmin.get('usageLog')
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(superAdminActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UsageLogContainer)



// WEBPACK FOOTER //
// ./src/components/smart/UsageLogContainer.js